import React, {lazy, Suspense, useEffect} from 'react';
import {BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Loading from 'components/common/Loading';
import HttpAction from "modules/utils/HttpAction";
import axios from "axios";

//라우터목록
const LoginRouter = lazy(() => import('modules/routers/LoginRouter'));
const MainRouter = lazy(() => import('modules/routers/MainRouter'));
const AdminRouter = lazy(() => import('modules/routers/AdminRouter'));
const ConventionRouter = lazy(() => import('modules/routers/ConventionRouter'));
const CommunityRouter = lazy(() => import('modules/routers/CommunityRouter'));
const ApplicationRouter = lazy(() => import('modules/routers/ApplicationRouter'));
const RankingRouter = lazy(() => import('modules/routers/RankingRouter'));
const SupportRouter = lazy(() => import('modules/routers/SupportRouter'));

//
const Routing = (props) => {
    const getpath = window.location.pathname; //도메인을 뺀 나머지 url
    const urldata = getpath.split("/");
    // 참가동의 url 판단 후 맞으면 sessionStorage에 set함 (로그인시 해당 페이지로 이동)
    if(urldata[urldata.length -1] === "Y") {
        sessionStorage.setItem("policyPath", getpath);
    }

    //
    const MoveLogin = () =>{
        //정보 초기화
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
    }

    //
    const AccessCheck = (permission) =>{
        //관리자인 경우
        if(permission == "Y"){
            //접근제한 URL
            // if(
                // urldata[1] == "ranking" ||
            //    urldata[1] == "login" ||
            //    // urldata[1] == "main" ||
            //    urldata[1] == "community"
            // ) { document.location.href = "/admin";}
        //일반사용자인 경우
        }else{
            //접근제한 URL
            if(urldata[1] == "login" ||
               urldata[1] == "admin" ||
               urldata[1] == "application" && urldata[2] == "write" ||
               urldata[1] == "application" && urldata[2] == "modify" ||
               urldata[3] == "viewRanking") { document.location.href = "/main"; }
        }
    }

    // 쿠키 조회 커스텀 함수
    const getCookie = function getCookieByName(cookie_name) {
        let x, y;
        let val = document.cookie.split(';');
        for (let i = 0; i < val.length; i++) {
            x = val[i].substr(0, val[i].indexOf('='));
            y = val[i].substr(val[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');

            // 앞과 뒤의 공백 제거하기
            if (x == cookie_name) {
                return unescape(y);
                // unescape로 디코딩 후 값 리턴
            }
        }
    }

    // 세션스토리지에 토큰이 없는 경우 cookie 조회
    if(sessionStorage.getItem("jwt") == null || sessionStorage.getItem("jwt") == undefined) {
        // 쿠키에 있는 토큰 조회, 있는 경우 셋팅
        if( getCookie("jwt") !== null &&  getCookie("jwt") !== "" &&  typeof getCookie("jwt") !== "undefined" ) {

            sessionStorage.setItem("jwt", getCookie("jwt"));

            // 쿠키에 토큰이 있다면 가져오고, 가져온 토큰 정보로 유저 권한 체크
            axios({
                url: `${process.env.REACT_APP_API_URL}/login/check`,
                method: 'get',
                headers: {
                    Authorization: `Bearer ${getCookie("jwt")}`
                }
            }).then(res => {
                if(res.data.userId != null){
                    sessionStorage.setItem("loginid", res.data.loginid);
                    sessionStorage.setItem("userId", res.data.userId);
                    sessionStorage.setItem("isAdmin", res.data.admin);
                }else{
                }
            }).catch(e => {
                // alert(e)
                sessionStorage.removeItem("jwt");
                sessionStorage.removeItem("userId");
                sessionStorage.removeItem("isAdmin");
                sessionStorage.removeItem("loginid");
                let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
                // document.location.href = `${process.env.REACT_APP_BIG_DATA_PLATFORM}/inno/login`;
            });
        }
    }

    //allow the person with token and with the urls down below
    if(sessionStorage.getItem("jwt") != null ||
        urldata[1] == "main" ||
        urldata[2] == "list" ||
        urldata[1] == "community" ||
        urldata[1] == "ranking" ||
        urldata[3] == "viewSummary"
    ){
        HttpAction({
            url: `/member/participant`,
            method: 'get',
        }).then(res => {
            if(res.data.id != null){
                AccessCheck(res.data.admin);
            }else{
                // MoveLogin();
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
            // MoveLogin();
        });
    //토큰이 없는 경우
    }else{
        MoveLogin();
    }

    return (
        <BrowserRouter>
            <Suspense fallback={<Loading/>}>
                <Switch>
                    {/*<Route path="/login" component={props => <LoginRouter {...props} />}/>*/}
                    <Route path="/main" component={props => <MainRouter {...props} />}/>
                    <Route path="/admin" component={props => <AdminRouter {...props} />}/>
                    <Route path="/convention" component={props => <ConventionRouter {...props} />} />
                    <Route path="/community" component={props => <CommunityRouter {...props} />} />
                    <Route path="/application" component={props => <ApplicationRouter {...props} />} />
                    <Route path="/ranking" component={props => <RankingRouter {...props} />} />
                    <Route path="/support" component={props => <SupportRouter {...props} />} />
                    <Redirect path="/" to="/main" />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}

export default Routing;
